export type LngLatBounds = [number, number, number, number];

export const isValidLngLat = (lng: number, lat: number): boolean =>
  Number.isFinite(lng) &&
  Number.isFinite(lat) &&
  lng >= -180 &&
  lng <= 180 &&
  lat >= -90 &&
  lat <= 90;

export const isValidLngLatBounds = (
  bounds?: number[] | null
): bounds is LngLatBounds => {
  if (!bounds || bounds.length !== 4) {
    return false;
  }
  const [west, south, east, north] = bounds;
  return (
    isValidLngLat(west, south) &&
    isValidLngLat(east, north) &&
    west <= east &&
    south <= north
  );
};

export const parseLngLatBounds = (
  value?: string | number[] | null,
  fallback?: LngLatBounds
): LngLatBounds | undefined => {
  if (Array.isArray(value) && isValidLngLatBounds(value)) {
    return value;
  }
  if (typeof value === "string" && value.trim()) {
    try {
      const parsed = JSON.parse(value);
      if (isValidLngLatBounds(parsed)) {
        return parsed;
      }
    } catch {
      // ignore invalid JSON
    }
  }
  return fallback;
};
